import { PriceInfoModel, SkusModel } from './../product/index';

export class LineItemModel {

  quantity: number;
  productId: string;
  tncUrl: string;
  skuId: string;
  displayName: string;
  sku: SkusModel;
  priceInfo: PriceInfoModel;
  childDcmCodes: Array<string>;
  email: string;
  id: string;
  productConfigurations: any[];
  orderConfigurations: any[];
  annual: boolean;
  maxQty: number;
  // bundleSku: string;
}
